import { Dispatch, SetStateAction } from 'react';
import { Modal, Button, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
interface RejectReasonModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  type?: 'offerManagement' | 'userManagement';
}

export default function GenerateLink({
  open,
  onClose,
  setOpen,
  type = 'offerManagement',
}: RejectReasonModalProps) {

  return (
    <Modal
      className="modal addCategory_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Generate Link</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form">
            {type === 'offerManagement' && (
              <div className="control_group">
                <label>Email Address</label>
                <TextField placeholder="Enter email" fullWidth hiddenLabel></TextField>
              </div>
            )}
            <div className="control_group">
              <label>Amount</label>
              <TextField placeholder="Enter amount" fullWidth hiddenLabel></TextField>
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_primary" onClick={() => setOpen(false)}>Submit</Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
